let malls = '';
if (process.env.NODE_ENV === 'production') {
  malls = (window.location.protocol+'//' + window.location.host)+'/api';
}else{
    // malls = 'http://172.16.0.82:7002/api'; // http://localhost:8000/api  /  /ceshi
    malls = '/ceshi/api'
}
export const baseURL = {
  seeHouseClientService: malls,
}

